

import React, { useState } from "react";
import axios from "axios";
import { FiCheck } from "react-icons/fi";

import { getCustomerSession } from "../../utils/applyFlowSession";
import { persistJourneyFromApi } from "../../utils/applyNewJourney";
import fundwalelogo from "../../assets/images/Fundswalle_Logo.png";

const SAVE_CAM_URL =
  "https://fundswalla.in/index.php/Api/TaskApi/savePaydayCAMDetailsData";

const SelfieSuccessPage = ({ setScreen }) => {
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  const handleProceed = async () => {
    if (submitting) return;

    try {
      setSubmitting(true);
      setError("");

      const stored = getCustomerSession() || {};
      const saved = stored?.saved_fields || {};

      const leadId = String(
        stored?.lead_id ||
        saved?.lead_id ||
        ""
      ).trim();

      if (!leadId) {
        throw new Error("Lead ID is missing");
      }
      const userId = String(
  stored?.user_id ||
  saved?.user_id ||
  stored?.session_data?.user_id ||
  stored?.bureauMobileBre?.credeau_response?.user_id ||
  saved?.bureauMobileBre?.credeau_response?.user_id ||
  ""
).trim();

console.log("USER ID FROM SESSION:", userId);

if (!userId) {
  throw new Error("User ID is missing from session");
}

      const monthlySalary = Number(
        String(
          stored?.monthly_income ||
          saved?.monthly_income ||
          saved?.salary ||
          0
        ).replace(/,/g, "")
      );

      const loanAmount = Number(
        String(
          stored?.loan_amount ||
          saved?.loan_amount ||
          0
        ).replace(/,/g, "")
      );

      const mobileBre =
        stored?.bureauMobileBre ||
        saved?.bureauMobileBre ||
        {};

      const cibilScore =
        mobileBre?.bureau_score ||
        mobileBre?.data?.bureau_score ||
        mobileBre?.bureau_features?.bureau_score ||
        saved?.cibil_score ||
        saved?.bureau_score ||
        "";

      const obligations =
        mobileBre?.bureau_features?.obligation ??
        mobileBre?.data?.bureau_features?.obligation ??
        saved?.obligations ??
        "";

const dobRaw = String(
  saved?.aadhaar_dob ||
  stored?.aadhaar_dob ||
  saved?.aadhaar_profile?.dobRaw ||
  saved?.aadhaar_profile?.dob ||
  stored?.aadhaar_profile?.dobRaw ||
  stored?.aadhaar_profile?.dob ||
  ""
).trim();

const dateOfBirth = (() => {
  if (!dobRaw) return "";

 
  if (/^\d{4}-\d{2}-\d{2}$/.test(dobRaw)) {
    return dobRaw;
  }

  if (/^\d{2}\/\d{2}\/\d{4}$/.test(dobRaw)) {
    const [day, month, year] = dobRaw.split("/");
    return `${year}-${month}-${day}`;
  }

  if (/^\d{2}-\d{2}-\d{4}$/.test(dobRaw)) {
    const [day, month, year] = dobRaw.split("-");
    return `${year}-${month}-${day}`;
  }

  return dobRaw;
})();

console.log("DOB FROM SESSION:", dobRaw);
console.log("DOB FOR API:", dateOfBirth);

  const salaryDate = String(
  saved?.salary_date ||
  stored?.salary_date ||
  ""
).trim();

const repaymentDate = (() => {
  if (!salaryDate) return "";


  if (/^\d{6}$/.test(salaryDate)) {
    const day = salaryDate.slice(0, 2);
    const month = salaryDate.slice(2, 4);
    const year = `20${salaryDate.slice(4, 6)}`;

    return `${year}-${month}-${day}`;
  }

 
  if (/^\d{2}\/\d{2}\/\d{2}$/.test(salaryDate)) {
    const [day, month, year] = salaryDate.split("/");

    return `20${year}-${month}-${day}`;
  }


  if (/^\d{2}-\d{2}-\d{2}$/.test(salaryDate)) {
    const [day, month, year] = salaryDate.split("-");

    return `20${year}-${month}-${day}`;
  }

  if (/^\d{4}-\d{2}-\d{2}$/.test(salaryDate)) {
    return salaryDate;
  }

  return salaryDate;
})();
      const payload = new URLSearchParams();

      payload.append("lead_id", leadId);
payload.append( "date_of_birth", dateOfBirth);
      payload.append(
        "monthly_salary",
        String(monthlySalary)
      );

      payload.append(
        "loan_amount",
        String(loanAmount)
      );

      payload.append(
        "cibil_score",
        String(cibilScore)
      );

      payload.append(
        "repayment_date",
        String(repaymentDate)
      );

      payload.append(
        "obligations",
        String(obligations)
      );

      console.log(
        "========== SAVE PAYDAY CAM REQUEST =========="
      );

      console.log(
        Object.fromEntries(payload.entries())
      );

      const response = await axios.post(
        SAVE_CAM_URL,
        payload,
        {
          headers: {
            "Content-Type":
              "application/x-www-form-urlencoded",
          },
          timeout: 30000,
          validateStatus: () => true,
        }
      );

      console.log(
        "========== SAVE PAYDAY CAM RESPONSE =========="
      );

      console.log("STATUS:", response.status);
      console.log("RESPONSE:", response.data);

      if (
        response.status >= 200 &&
        response.status < 300 &&
        response.data?.status === true
      ) {
        console.log(
          "SAVE PAYDAY CAM SUCCESS"
        );

        const journey = persistJourneyFromApi(
          response.data,
          "sectionLetter"
        );
        let targetScreen = journey.route || "sectionLetter";
        if (targetScreen === "selfieSuccess") {
          targetScreen = "sectionLetter";
        }

        console.log("========== CAM → NEXT ==========");
        console.log("route:", targetScreen);

        setScreen(
          `/apply-new/${targetScreen}`
        );

        return;
      }

      throw new Error(
  response.data?.err ||
  response.data?.msg ||
  response.data?.message ||
  "Unable to save CAM details."
);
    } catch (err) {
      console.error(
        "SAVE PAYDAY CAM ERROR:",
        err
      );

      console.error(
        "API RESPONSE:",
        err?.response?.data
      );


      setError(
  err?.response?.data?.err ||
  err?.response?.data?.msg ||
  err?.response?.data?.message ||
  err?.message ||
  "Unable to submit CAM details. Please try again."
);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section className="fw-screen fw-screen--selfie-success fw-fade">
      <div className="fw-brandmain">
        <img
          src={fundwalelogo}
          alt="Fundswalle"
          className="fw-brand__logo1"
        />
      </div>

      <div className="fw-selfie-success">
        <span className="fw-selfie-success__icon">
          <FiCheck />
        </span>

        <p>
          Congratulations. Your application has
          <br />
          been submitted
        </p>

        {error && (
          <p className="fw-error">
            {error}
          </p>
        )}
      </div>

      <div className="fw-screen__footer">
        <button
          type="button"
          className="fw-btn fw-btn--dark fw-btn--full"
          onClick={handleProceed}
          disabled={submitting}
        >
          {submitting
            ? "Processing..."
            : "Proceed"}
        </button>
      </div>
    </section>
  );
};

export default SelfieSuccessPage;